export const serviceRequestLabels = {
  EXTENSION: "One-time due-date extension", BILLING_DAY: "Recurring billing-day change",
  DEVICE: "Use my own device", UPGRADE: "Upgrade / buy a device", PHONE_NUMBER: "Phone-number change",
  ACTIVATION: "New line activation",
};
export const serviceRequestStatuses = {
  PENDING: "Awaiting staff review", IN_PROGRESS: "In progress", APPLIED: "Applied automatically",
  COMPLETED: "Completed", REJECTED: "Not approved", SCHEDULED: "Scheduled automatically",
};
export const openServiceRequestStatuses = ["PENDING", "IN_PROGRESS"];
export function groupPortalServiceRequests(requests) {
  const current = [], past = [];
  for (const request of requests) {
    if (["COMPLETED", "REJECTED"].includes(request.status)) past.push(request);
    else current.push(request);
  }
  return { current, past };
}
export const activationKindLabels = { PHONE: "Phone", TABLET: "Tablet / data only", WATCH: "Smartwatch", ROAMING: "International roaming" };
export function openServiceRequestCount(requests) {
  return requests.filter(request => openServiceRequestStatuses.includes(request.status)).length;
}
export function serviceRequestDetails(request) {
  const details = request.details;
  if (details.deliveryPurpose) return [details.carrier, details.model, "eSIM", details.deliveryPurpose].filter(Boolean).join(" | ");
  if (request.type === "EXTENSION") return `Requested due date: ${details.dueDate}`;
  if (request.type === "BILLING_DAY") return `Requested monthly billing day: ${details.billingDay}`;
  if (request.type === "PHONE_NUMBER") {
    const preference = details.areaCodePreference === "KEEP_CURRENT"
      ? `Keep current area code${details.currentAreaCode ? ` (${details.currentAreaCode})` : ""}.`
      : details.areaCodePreference === "DIFFERENT" ? `Desired area code: ${details.requestedAreaCode}.`
        : details.areaCodePreference === "NO_PREFERENCE" ? "No area code preference." : "Area code preference not provided.";
    return `${preference} New number to be assigned by the carrier after staff review; area code availability is not guaranteed.`;
  }
  return [
    [details.make, details.model].filter(Boolean).join(" "),
    details.imei && `IMEI: ${details.imei}`, details.imei2 && `IMEI 2: ${details.imei2}`,
    details.serial && `S/N: ${details.serial}`, details.eid && `EID: ${details.eid}`,
    details.simType && (details.simType === "ESIM" ? "eSIM" : "Physical SIM"),
    ...(request.type === "ACTIVATION" ? [
      activationKindLabels[details.activationKind],
      ...(details.activationKind !== "ROAMING" ? [
        `Color: ${details.color}`, `Preferred due day: ${details.preferredBillingDay} (not confirmed)`,
        details.carrierUnlocked ? "Carrier unlocked" : `Locked to: ${details.lockedCarrier}`,
      ] : []),
      details.activationKind === "ROAMING" ? `Countries: ${details.countries} | Travel: ${details.travelStart} through ${details.travelEnd}`
        : details.portIn ? `Port in: ${details.portPhone} from ${details.portCarrier}` : "New number requested",
    ] : []),
  ].filter(Boolean).join(" | ");
}
